import React, { Component } from 'react'
import FontAwesome from 'react-fontawesome'
import { MuvicardService } from '../../../../services/muvicard.service'
import LinkButton from '../../../../components/buttons/link-button.component'
import { routes } from '../../../../constants/routes.constants'

import {
	ConclusionPage,
	WaitingMessage
} from '../../../muvicard-register/styles.style'

export class MuvicardProposalValidationPage extends Component {
	constructor(props) {
		super(props)
		this.user = props.user
		this.state = {
			hasResponse: false,
			errorMessage: ''
		}
	}

	componentWillMount() {
		MuvicardService.validateAdmission()
			.then(response => {
				this.setState({
					hasResponse: true,
					errorMessage: response.errors
				})
				if (response.length === 0) {
					this.setState({
						errorMessage:
							'Por favor, faça login no Muviflex para prosseguir...'
					})
				} else if (response.success) {
					this.acceptProposal()
				}
			})
			.catch(error => {
				this.setState({
					hasResponse: true
				})
			})
	}

	acceptProposal = () => {
		this.props.onAcceptProposal()
	}

	renderContent = () => {
		const { hasResponse, errorMessage } = this.state
		const { proposalAccepted } = this.props
		const hasMuvicardError = hasResponse && errorMessage != null && errorMessage.length > 0 && errorMessage[0].indexOf("Você já possui um cartão Muvicard ativo em sua conta.") >= 0

		if (!hasResponse) {
			return (
				<div align="center">
					<FontAwesome name="spinner" size="2x" className="icon" spin />
					<p align="center">Por favor aguarde...</p>
				</div>
			)
		} else if (!proposalAccepted) {
			return (
				<div align="center">
					<FontAwesome
						name="exclamation-circle"
						size="2x"
						className="icon yellow"
					/>
					<p>{errorMessage}</p>
					<br />
					{hasMuvicardError ? (
						<LinkButton to={`${routes.MEU_CARTAO}`}>
							Ir para Meu Cartão
						</LinkButton>
					) : (null)}
				</div>
			)
		} else {
			return (
				<div align="center">
					<FontAwesome name="spinner" size="2x" className="icon" spin />
				</div>
			)
		}
	}

	render() {
		return (
			<ConclusionPage>
				<WaitingMessage>
					<div className="box-wait" align="center">
						{this.renderContent()}
					</div>
				</WaitingMessage>
			</ConclusionPage>
		)
	}
}
